import BaseRoundChart from './BaseRoundChart';
import { DonutChartOption } from '../ChartOption/RoundChartOption';
import React from 'react';
import { TwoDimGraphProps } from '../../types';

const DonutChart = ({
    settings,
    data,
    height,
    width,
    orderedColumns,
    isPdfModeActivated,
    isPngModeActivated,
    onClick = () => {},
}: TwoDimGraphProps): React.ReactElement => {
    const donutChartOptionBuilder = new DonutChartOption(
        orderedColumns,
        settings,
        data,
        width,
        height,
        isPdfModeActivated,
        isPngModeActivated,
    );

    return (
        <BaseRoundChart
            height={height}
            width={width}
            className="donut-chart"
            orderedColumns={orderedColumns}
            onClick={onClick}
            optionBuilder={donutChartOptionBuilder}
        />
    );
};

export default DonutChart;
